import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const SleepLogPage = lazy(() => import("./SleepLogPage.tsx"));

const SleepLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <SleepLogPage />
    </Suspense>
  );
};

export default SleepLogPageLazy;
